<script>
import { mapState, mapActions } from 'vuex';
import TwTitleBar from '../../../components/TwTitleBar';

export default {
  name: 'VisitGroupWrapper',
  components: {
    TwTitleBar,
  },
  methods: {
    ...mapActions({
      loadXmlChannels: 'visitgroup/loadXmlChannels',
      clearState: 'visitgroup/clearState',
    }),
  },
  computed: {
    ...mapState({
      xmlChannels: state => state.visitgroup.xmlChannels.items,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('menu.ski.title'), to: '', disabled: true },
        { text: 'VisitGroup', to: '', disabled: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ];
    },
  },
  mounted() {
    if (!this.xmlChannels.length) {
      this.loadXmlChannels();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearState();
    next();
  },

};
</script>

<template>
  <v-content>
    <tw-title-bar
      :breadcrumbs="breadcrumbs"
      title="VisitGroup"
    />
    <v-container>
      <v-layout row>
        <v-flex xs12>
          <router-view/>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>




// WEBPACK FOOTER //
// src/pages/ski/visitgroup/VisitGroupWrapper.vue